import { formatMoney } from 'accounting'

import { faCog, faPencil } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {
  Box, Checkbox, IconWithMenu, Link, ListItem, Text,
} from '@domain-group/suit-theme'

import useAccountingIntegration from '@hooks/useAccountingIntegration'
import useCreditNote, { generateUrls } from '@hooks/useCreditNote'

import type { CreditNoteModel } from '@models/types'

import CreditNoteActionButton from '../../CreditNoteActionButton'

interface CreditNoteListItemProps {
  accountingIntegrationPayload: ReturnType<typeof useAccountingIntegration>,
  creditNote: CreditNoteModel,
}

const CreditNoteListItem = (props: CreditNoteListItemProps) => {
  const { accountingIntegrationPayload, creditNote } = props

  const creditNotePayload = useCreditNote(creditNote)
  const {
    campaign,
    creditNote: {
      campaign_id,
      contact_name,
      dates: {
        created,
      },
      id,
      reference,
      total,
    },
  } = creditNotePayload

  const { editCreditNoteUrl } = generateUrls({ id }, { prefixRoute: `agency/campaigns/${campaign_id}` })

  return (
    <Box
      marginBottom="large"
      variant="white"
      flexDirection="column"
    >
      {/*
       // @ts-expect-error TS2339 */}
      <ListItem.WithCheckbox
        boxProps={{
          paddingX: 'large',
          paddingY: 'medium',
        }}
        checkbox={(
          <Checkbox
            checked
            fontSize="small"
            style={{ cursor: 'auto' }}
          />
        )}
        disableHover
      >
        <Box flexDirection="column" marginRight="auto" width={['150px', 'auto']}>
          <Text color="green" fontSize="small" variant="ellipsis">
            {/*
             // @ts-expect-error TS2339 */}
            {campaign.address || reference}
          </Text>

          <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small" variant="ellipsis">
            {reference}
          </Text>
        </Box>

        <Box justifyContent="flex-end" width="fit-content">
          <CreditNoteActionButton
            accountingPayload={accountingIntegrationPayload}
            creditNote={creditNote}
          />
        </Box>
        {/*
       // @ts-expect-error TS2339 */}
      </ListItem.WithCheckbox>

      <Box justifyContent="space-between" padding="large">
        <Box flexDirection="column" fontSize="xsmall" justifyContent="center" maxWidth="50%">
          <Text color="faintGrey" variant="ellipsis">
            {`Invoice #${id} - ${created.date}`}
          </Text>

          <Text color="bodyFontLightColor" marginTop="small" variant="ellipsis">
            {contact_name}
          </Text>
        </Box>

        <Box
          flexDirection="column"
          marginRight="large"
          textAlign="right"
          justifyContent="center"
        >
          <Text fontSize="medium">
            {formatMoney(total)}
          </Text>
        </Box>

        <IconWithMenu
          boxProps={{ alignItems: 'center', position: 'relative' }}
          icon={(
            <Link greyLink>
              <FontAwesomeIcon icon={faCog} />
            </Link>
          )}
          shouldUsePortal
        >
          {/*
           // @ts-expect-error TS2741 */}
          <IconWithMenu.Menu closeOnClick>
            <Link href={editCreditNoteUrl}>
              <FontAwesomeIcon icon={faPencil} />Manage Credit Note
            </Link>
          </IconWithMenu.Menu>
        </IconWithMenu>
      </Box>
    </Box>
  )
}

export default CreditNoteListItem
